require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/get-iterator.js
// module id = 495
// module chunks = 4 5 6 7 10 11 13 14 15 18 19 21 22 24 25 59